import {
    EnvironmentProviders,
    InjectionToken,
    makeEnvironmentProviders,
} from '@angular/core';
import { NotificationConfig } from '../models/notification/notification.model';

export const NOTIFICATION_CONFIG = new InjectionToken<NotificationConfig>(
    'NOTIFICATION_CONFIG',
);

export function provideNotificationConfig(
    urlFactory: () => NotificationConfig,
): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: NOTIFICATION_CONFIG, useFactory: urlFactory },
    ]);
}
